export default {"src":"/_next/static/media/Contact.3258e020.svg","height":60,"width":232,"blurWidth":0,"blurHeight":0};